import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import { BlindReceivePermissions } from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';
import InfoButton from 'src/sections/enter_receipt/custom_grid_cell/InfoButton';
import ReceiptDetailsCell from 'src/sections/enter_receipt/custom_grid_cell/ReceiptDetailsCell';
import OfflineSupplierCell from 'src/sections/enter_receipt/custom_grid_cell/cells/OfflineSupplierCell';

export const useReceiptColumns = () => {
  const isBlindReceive = usePermission({ permissions: BlindReceivePermissions });

  const receiptColumns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'errors',
        title: '',
        width: 40,
        component: InfoButton,
        menu: false,
      },
      {
        field: 'receivingReceiptId',
        title: 'Receipt #',
        filter: 'numeric',
        dataType: 'number',
        component: ReceiptDetailsCell,
        filterFormat: '#',
        step: 1,
      },
      {
        field: 'receiptStatus',
        title: 'Status',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'buyerCompanyName',
        title: 'Company',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'buyerName',
        title: 'Buyer Name',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'creationDate',
        title: 'Status Date',
        filter: 'date',
        format: '{0:MM/dd/yyyy}',
        dataType: 'date',
        component: OfflineSupplierCell,
      },
      {
        field: 'supplierName',
        title: 'Supplier Name',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      ...(isBlindReceive
        ? []
        : ([
            {
              field: 'receiptTtlQty',
              title: 'Total Qty Received',
              filter: 'numeric',
              dataType: 'number',
              filterFormat: '#',
              step: 1,
              component: OfflineSupplierCell,
            },
          ] as GridColumn<any>[])),
    ],
    [isBlindReceive]
  );
  return receiptColumns;
};
export default useReceiptColumns;
